import {
  Input,
  Output,
  Component,
  OnDestroy,
  ElementRef,
  HostBinding,
  EventEmitter,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'sn-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'sn-alert alert',
    role: 'alert',
  },
})
export class SnAlertComponent implements OnDestroy {
  @Input()
  set type(value: string) {
    if (this._type !== value) {
      if (this._type) {
        this._elementRef.nativeElement.classList.remove(`alert-${this._type}`);
      }

      if (value) {
        this._elementRef.nativeElement.classList.add(`alert-${value}`);
      }

      this._type = value;
    }
  }

  @Input()
  @HostBinding('class.alert-dismissible')
  public dismissible: boolean;

  @Output()
  public readonly closed = new EventEmitter<void>();

  private _type: string;

  constructor(private readonly _elementRef: ElementRef) {
    this.type = 'warning';
  }

  public ngOnDestroy(): void {
    this.closed.complete();
  }

  public close(): void {
    this.closed.emit();
  }
}
